import { render, staticRenderFns } from "./CreateLocaleModal.vue?vue&type=template&id=025011ec&"
import script from "./CreateLocaleModal.vue?vue&type=script&lang=js&"
export * from "./CreateLocaleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports